<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="'[Downline] - AMOS365'" />

            <nav aria-label="breadcrumb" class="d-print-none">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/reports">My Saved Reports</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" v-if="!report.id">
                        Downline Report
                    </li>
                    <template v-else>
                        <li class="breadcrumb-item">
                            <router-link :to="`/reports/view/${report.id}`">{{ report.report_name }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Edit
                        </li>
                    </template>

                </ol>
            </nav>

            <h4 class="font-weight-bold py-3 mb-4">
                <span class="d-print-none">Downline</span> <span v-if="report.id" class="text-muted"><span class="d-print-none">/ </span>{{ report.report_name }}</span>
            </h4>

            <div class="row d-print-none" v-if="can_edit">
                <div class="col-md-8 col-12 mb-md-0 mb-4">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-lg-3 text-lg-right" :class="{'text-danger': errors.date_of_change}">
                                    Date of Change: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <input type="date" name="" v-model="date_of_change" placeholder="Select the Date of Change" class="form-control" :class="{'is-invalid': errors.date_of_change}" />
                                    <small class="text-info">Use this to run point-in-time reports, either in the past or future.</small>

                                    <div class="text-danger mt-2" v-if="errors.date_of_change">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.date_of_change">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 text-lg-right">
                                    Product(s): <i class="fa fa-sm fa-asterisk text-danger"></i>
                                    <div class="mt-1">
                                        <b-form-checkbox v-model="select_all" :value="true" :unchecked-value="false" plain>Select All</b-form-checkbox>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <v-select
                                        v-model="selected_products"
                                        :options="products"
                                        :reduce="product => product.id"
                                        label="product_name"
                                        :class="{'is-invalid': errors.product_ids}"
                                        :placeholder="`-- Select Product(s) --`"
                                        multiple
                                        size="sm"
                                        v-if="false" />

                                        <multiselect
                                            v-model="selected_products"
                                            label="product_name"
                                            track-by="id"
                                            placeholder="Select Product(s)"
                                            open-direction="bottom"
                                            :options="products"
                                            :multiple="true"
                                            :limit-text="limitText"
                                            :limit="3"
                                            :class="{'is-invalid': errors.product_ids}"
                                            :showLabels="false" />

                                    <div class="text-danger mt-2" v-if="errors.product_ids">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.product_ids">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 text-lg-right" :class="{'text-danger': errors.contract_status_id, 'text-muted-no': !errors.contract_status_id}">
                                    Contract Status:
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <v-select v-model="contract_status_id" :options="contract_statuses" :reduce="status => status.id" label="contract_status_label" placeholder="-- Select a Contract Status --" multiple />

                                    <div class="text-danger mt-2" v-if="errors.contract_status_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.contract_status_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 text-lg-right" :class="{'text-danger': errors.manager_type, 'text-muted-no': !errors.manager_type}">
                                    Manager Type: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <b-form-radio-group v-model="manager_type" name="manager_type" plain>
                                        <b-form-radio value="Agency">Agency</b-form-radio>
                                        <b-form-radio value="Agent">Agent</b-form-radio>
                                    </b-form-radio-group>

                                    <div class="text-danger mt-2" v-if="errors.manager_type">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.manager_type">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-3 text-lg-right" :class="{'text-danger': errors.manager_id}">
                                    Manager: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <span v-if="!manager_type">-- Select a Manager Type --</span>

                                    <v-select
                                        v-if="manager_type === 'Agency'"
                                        v-model="manager_id_agency"
                                        :options="agencies"
                                        :reduce="agency => agency.id"
                                        label="agency_name"
                                        :class="{'is-invalid': errors.manager_id}"
                                        placeholder="-- Select an Agency --" />

                                    <v-select
                                        v-if="manager_type === 'Agent'"
                                        v-model="manager_id_agent"
                                        :options="agents"
                                        :reduce="agent => agent.id"
                                        label="agent_name"
                                        :class="{'is-invalid': errors.manager_id}"
                                        placeholder="-- Select an Agent --"
                                        @search="searchManagerAgents"
                                        :filterable="false" />

                                    <div class="text-danger mt-2" v-if="errors.manager_id">
                                        <ul class="list-unstyled">
                                            <li v-for="err in errors.manager_id">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3 text-lg-right" :class="{'text-danger': errors.group_by}">
                                    Group By: <i class="fa fa-sm fa-asterisk text-danger"></i>
                                </div>
                                <div class="col-lg-6 mt-lg-0 mt-2">
                                    <b-form-radio-group v-model="group_by" name="group_by" plain>
                                        <b-form-radio value="product">Product</b-form-radio>
                                        <b-form-radio value="manager_seller">Manager/Agent/Agency</b-form-radio>
                                    </b-form-radio-group>
                                </div>
                            </div>

                            <div v-if="errors.report_errors" class="alert alert-danger mt-2">
                                <ul>
                                    <li v-for="err in errors.report_errors">{{ err }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="card">
                        <div class="card-header">Save Report:</div>
                        <div class="card-body">
                            <b-form-input v-model="report.report_name" placeholder="Enter Report Name" :class="{'is-invalid': errors.report_name}" size="sm" />

                            <div class="form-group mt-2">
                                <b-form-textarea v-model="report.description" placeholder="Enter a Report Description (Optional)" rows="4" />
                            </div>

                            <div class="form-group mt-2" v-if="$root.hasPermission('reports.manage.all')">
                                <b-form-checkbox v-model="report.is_public" :value="1" :unchecked-value="0" plain>Public Report <i class="fa fa-question-circle" title="If set to Public, this report will be available to all users with the basic reporting view permissions"></i></b-form-checkbox>
                            </div>

                            <div class="form-group mt-2">
                                <b-form-checkbox v-model="save_as_new" :value="true" :unchecked-value="false" v-if="report.id" plain>Save As New Report</b-form-checkbox>
                            </div>

                            <div class="form-group mt-2">
                                <button type="text" class="btn btn-sm btn-default" v-on:click="saveReport()" :disabled="generating"><i class="fa fa-save"></i> Save Report</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-4" v-else>
                <div class="card-body">
                    {{ report.description }}
                </div>
            </div>

            <div class="mb-4 d-print-none">
                <div class="float-left">
                    <button type="button" class="btn btn-sm btn-warning" v-on:click="getResult()" :disabled="generating">
                        <template v-if="generating"><i class="fa fa-sync fa-spin"></i> Generating</template>
                        <template v-else><i class="fa fa-list"></i> Generate</template>
                    </button>
                </div>
                <div class="float-left ml-2">
                    <button type="button" class="btn btn-sm btn-default" v-on:click="getResult(true)" :disabled="generating">
                        <i class="fa fa-file-alt"></i> Export</span>
                    </button>
                </div>
                <div class="float-left ml-2">
                    <b-form-radio-group v-model="export_type" name="export_type" plain>
                        <b-form-radio value="xlsx">
                            <i class="fa fa-file-excel"></i> XLSX
                        </b-form-radio>
                        <b-form-radio value="pdf">
                            <i class="fa fa-file-pdf"></i> PDF
                        </b-form-radio>
                    </b-form-radio-group>
                </div>
                <div class="float-left">
                    <b-form-checkbox v-model="export_url" :value="true" :unchecked-value="false" plain>
                        Add Export to URL
                    </b-form-checkbox>
                </div>
                <div class="clearfix"></div>
            </div>

            <div class="card mt-2" v-if="report_has_run">
                <div class="card-body">
                    <table class="table table-bordered small">
                        <thead class="thead-light">
                            <tr>
                                <th :colspan="max_level">Manager/Agency/Agent</th>
                                <th style="width: 10%">Agent/Agency NPN</th>
                                <th style="width: 10%">Manager</th>
                                <th style="width: 10%">Man. NPN</th>
                                <th style="width: 10%;">Product</th>
                                <th style="width: 10%;">Level</th>
                                <th style="width: 10%;">Writing#</th>
                                <th style="width: 10%;">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in table_rows">
                                <td v-for="i in (max_level - (max_level - row.downline_level) - 1)" :key="i" class="bg-light">
                                    <i class="fa fa-angle-right"></i>
                                </td>
                                <td :colspan="(max_level - row.downline_level + 1)">
                                    <router-link :to="'/' + (row.seller_type == 'Agency' ? 'agencies' : 'agents') + '/view/'+row.seller_id" class="print-link-fix">
                                        {{ row.seller_name }}
                                    </router-link>
                                </td>
                                <td>
                                    {{ row.npn }}
                                </td>
                                <td>
                                    <router-link :to="'/' + (row.manager_type == 'Agency' ? 'agencies' : 'agents') + '/view/'+row.manager_id" class="print-link-fix" v-if="row.manager_id">{{ row.manager_name }}</router-link>
                                </td>
                                <td>
                                    {{ row.manager_npn }}
                                </td>
                                <td>{{ row.product_name }}</td>
                                <td>{{ row.product_level_name }}</td>
                                <td>
                                    <a :href="`/contracts/view/${row.id}`" target="_blank" v-if="row.id" class="d-print-none text-right d-print-none">View</a><span v-if="row.writing_nbr"> <span class="d-print-none">-</span> {{ row.writing_nbr }}</span>
                                </td>
                                <td>
                                    {{ row.contract_status_name }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import Multiselect from 'vue-multiselect';

    export default {
        components: {
            Multiselect
        },

        data() {
            return {
                id: this.$route.params.id,
                date_of_change: moment().format("YYYY-MM-DD"),
                loading: true,
                saving: false,
                generating: false,
                report_has_run: false,
                save_as_new: false,
                downline: {},
                table_rows: [],
                max_level: null,
                product: null,
                manager: null,
                manager_type: null,
                manager_id_agent: null,
                manager_id_agency: null,
                select_all: false,
                products: [],
                selected_products: [],
                contract_status_id: [],
                products_loading:false,
                can_edit: false,
                export_type: 'xlsx',
                export_url: false,
                group_by: 'manager_seller',
                agencies: [],
                agents: [],
                contract_statuses: [],
                default_statuses: [],
                errors: {},
                report: {},
            }
        },

        watch: {
            select_all(newVal, oldVal){
                //Check True
                if(newVal !== true)
                {
                    //Reset
                    this.selected_products = [];

                    //Stop Here
                    return;
                }

                //Set
                this.selected_products = this.products;
            },

            export_url(new_val, old_val){
                //RUn the helper
                this.updateUrlParams();
            },
        },

        computed: {

            selected_product_ids(){
                //Setup
                var ids = [];

                //Loop
                for (var i = 0; i < this.selected_products.length; i++)
                {
                    //Push the ID
                    ids.push(this.selected_products[i].id);
                }

                //Send it;
                return ids;
            },

            contractStatusOptions(){
                //Setup
                var options = [{value: null, text: '-- Select Contract Status --'}];

                //Main Loop
                for(var i = 0; i < this.contract_statuses.length; i++)
                {
                    options.push({value: this.contract_statuses[i].id, text: this.contract_statuses[i].contract_status_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            getReport(){
                //setup
                var payload = this.$route.query;

                //Send it
                this.$http
                .get('/reports/downline' + (this.id ? '/'+this.id : ''), payload)
                .then(response => {
                    //Set it
                    this.products = response.data.products;
                    this.agencies = response.data.agencies;
                    this.contract_statuses = response.data.contract_statuses;
                    this.default_statuses = response.data.default_statuses;
                    this.can_edit = response.data.can_edit;

                    //Set the data
                    if(response.data.report)
                    {
                        //Set it
                        this.report = response.data.report;

                        //Set some values from the report
                        var filters = JSON.parse(this.report.filter_fields);

                        //Build the Selected Products from
                        if(filters.select_all)
                        {
                            //Set Products to Select
                            this.selected_products = this.products;
                        }
                        else
                        {
                            for (var i = 0; i < this.products.length; i++)
                            {
                                //Check if in the saved products
                                if(filters.product_ids.indexOf(this.products[i].id) !== -1)
                                {
                                    this.selected_products.push(this.products[i]);
                                }
                            }
                        }

                        //Set it
                        //this.selected_products = filters.product_ids;
                        this.group_by = filters.group_by;
                        this.manager_type = filters.manager_type;
                        this.select_all = filters.select_all;
                        this['manager_id_' + this.manager_type.toLowerCase()] = filters.manager_id;

                        //Push the Agent onto the Options
                        if(filters.manager_type === 'Agent' && filters.manager_name)
                        {
                            this.agents.push({id: parseInt(filters.manager_id), agent_name: filters.manager_name});
                        }

                        //Check for Export TYpe
                        if(filters.export_type)
                        {
                            this.export_type = filters.export_type;
                        }
                    }

                    //Set the data
                    if(response.data.manager)
                    {
                        //Set it
                        this.manager = response.data.manager;
                        this.manager_type = response.data.manager.manager_type;

                        //Check the Type
                        if(this.manager_type === 'Agent')
                        {
                            this.agents.push({id: this.manager.id, agent_name: this.manager.manager_name});
                        }

                        //Push
                        this['manager_id_' + this.manager_type.toLowerCase()] = this.manager.id;
                    }

                    //Check for a product_id in the request
                    //if(this.$route.query.product_id)
                    if(response.data.product)
                    {
                        //Push
                        //this.selected_products.push(parseInt(this.$route.query.product_id));
                        this.selected_products.push(response.data.product);
                    }

                    //IF ALL the values are present, call it
                    if( this.selected_products.length > 0 && this.manager_type !== null && (this.manager_id_agent || this.manager_id_agency) )
                    {
                        //Fetch it
                        //this.getResult();
                    }

                    //Setup
                    this.contract_status_id = this.default_statuses;

                    //Check URL for URL
                    if(Object.keys(this.$route.query).length > 0)
                    {
                        //Set params from URL
                        this.setParamsFromUrl();

                        //Generate or Export it
                        this.getResult( this.export_url );
                    }
                })
                .catch(error => {
                    //Debugging
                    console.log(error);
                })
                .then(response => {
                    //SHow loading
                    this.loading = false;
                });
            },

            getResult(do_export = false){
                //Setup
                this.generating = true;
                this.errors = {};

                //Validation
                if(!this.manager_type)
                {
                    //Alert
                    this.$toastr.e('Manager Type is required');

                    this.errors = {'manager_type': ['Manager Type is required']};

                    //Rest
                    this.generating = false;

                    //Stop
                    return;
                }

                //Setup
                var payload = {
                    product_ids: this.selected_product_ids,
                    manager_type: this.manager_type,
                    manager_id: parseInt(this['manager_id_'+this.manager_type.toLowerCase()]),
                    export: do_export,
                    select_all: this.select_all,
                    group_by: this.group_by,
                    report_id: this.report.id ? this.report.id : null,
                    export_type: this.export_type,
                    contract_status_id: this.contract_status_id,
                    date_of_change: this.date_of_change,
                };

                //Send it
                this.$http
                .post('/reports/downline', payload)
                .then(response => {
                    //Update
                    this.updateUrlParams();

                    //Check for Queued
                    if(response.data.queued === true)
                    {
                        //Clear the Table and Alert the User
                        this.table_rows = [];

                        //Alert the User
                        this.$toastr.s(response.data.message);

                        //Turn off the flag
                        this.report_has_run = false;

                        //Stop Here
                        return;
                    }

                    //Check for export
                    if(do_export)
                    {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    }
                    else
                    {
                        //Set it
                        this.max_level = response.data.max_level;
                        //this.downline = response.data.downline;
                        this.table_rows = response.data.table_rows;
                        this.manager = response.data.manager;
                    }

                    //SEt the helper
                    this.report_has_run = true;
                })
                .catch(error => {
                    //SHow loading
                    this.generating = false;

                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Debugging
                        console.log(error);

                        //Alert the user
                        this.$toastr.e(error, 'Failed to Generate Report');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.generating = false;
                });
            },

            //Get the Customer
            saveReport(){
                //Loading
                this.generating = true;
                this.errors = {};

                //Validation
                if(!this.manager_type)
                {
                    //Alert
                    this.$toastr.e('Manager Type is required');

                    //Errors
                    this.errors = {'manager_type': ['Manager Type is required']};

                    //Rest
                    this.generating = false;

                    //Stop
                    return;
                }

                //Setup Manager Name
                var manager_name = null;

                //Get the manager name
                if(this.manager_type == 'Agency')
                {
                    for (var i = this.agencies.length - 1; i >= 0; i--)
                    {
                        //Check if
                        if(this.manager_id_agency == this.agencies[i].id)
                        {
                            manager_name = this.agencies[i].agency_name;
                        }
                    }
                }
                else
                {
                    for (var i = this.agents.length - 1; i >= 0; i--)
                    {
                        //Check if
                        if(this.manager_id_agent == this.agents[i].id)
                        {
                            manager_name = this.agents[i].agent_name;
                        }
                    }
                }

                //Append the Fields
                this.report.report_type = 'Downline';
                this.report.filter_fields = {
                    product_ids: this.selected_product_ids,
                    manager_type: this.manager_type,
                    manager_id: parseInt(this['manager_id_'+this.manager_type.toLowerCase()]),
                    manager_name: manager_name,
                    select_all: this.select_all,
                    group_by: this.group_by,
                    export_type: this.export_type,
                    contract_status_id: this.contract_status_id,
                };
                this.report.save_as_new = this.save_as_new;

                //Send it
                this.$http.post('/reports/save', this.report)
                    .then(response => {
                        //Set it
                        this.report = response.data;

                        //Alert
                        this.$toastr.s('Report Saved');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Generate Report');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.generating = false;
                    });
            },

            searchManagerAgents(search, loading, agent_type){
                //Minimum 3 characters
                if(search.length < 3)
                {
                    //Display an Alert?

                    //STop
                    return;
                }

                //Must call this to let VueSelect know what we are doing
                loading(true);

                //Build the Search Payload
                var payload = {
                    query: search,
                    limit: 20,
                    ascending: 1,
                    page: 1,
                    byColumn: 0,
                    orderBy: 'agents.last_name',
                    typeahead: true,
                    last_name_first: true,
                    add_active: true,
                };

                //Show a Loading INdicator?
                this.$http.get('/agents', payload)
                        .then(response => {
                            loading(false);

                            // //Set the Data
                            // var agents = response.data.data;

                            // //Loop and Build
                            // for (var i = 0; i < response.data.data.length; i++)
                            // {
                            //     agents.push({id: response.data.data[i].id, agent_name: (response.data.data[i].first_name + ' ' + response.data.data[i].last_name)})
                            // }

                            // //Set the values
                            this.agents = response.data.data;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                        .then(() => {

                        })
            },

            openPrint(){
                //Open it
                window.print();
            },

            limitText (count) {
              return `and ${count} other products`;
            },

            updateUrlParams(){
                //Setup
                var params = {
                    product_ids: this.select_all ? '' : this.selected_product_ids.join(','),
                    manager_type: this.manager_type,
                    manager_id: parseInt(this['manager_id_'+this.manager_type.toLowerCase()]),
                    select_all: this.select_all,
                    group_by: this.group_by,
                    contract_status_id: this.contract_status_id,
                    //export_type: this.export_type,
                };

                //console.log(params);

                //Build the URL
                var url = window.location.origin + window.location.pathname + '?';

                //Loop and Build
                var keys = Object.keys(params);

                //Loop
                for (var i = 0; i < keys.length; i++)
                {
                    //Append
                    url += (i > 0 ? '&' : '') + keys[i] + '=' + encodeURIComponent(params[keys[i]]);
                }

                //Check for Export Mode
                if(this.export_url === true)
                {
                    //Append the Export Flag
                    url += '&export_type=' + this.export_type;
                }

                //Push it
                //this.$router.push({path: this.$route.path, query: params });
                window.history.replaceState({}, '', url);
            },

            setParamsFromUrl(){
                //Get ALL the params
                var params = this.$route.query;

                //console.log(params);

                //Set the Param
                if(params.export_type)
                {
                    //Set it
                    this.export_type = params.export_type;

                    //Set the helper
                    this.export_url = true;
                }

                //Loop and Build
                var keys = Object.keys(params);

                //Loop
                for (var i = 0; i < keys.length; i++)
                {
                    //Set the value
                    switch(keys[i])
                    {
                        case 'product_ids':
                            //Check for All
                            if(params[keys[i]] == 'all')
                            {
                                //Set the products to All, the WATCH function handles this
                            }
                            else
                            {
                                //Explode on Comma??
                                var ids = params[keys[i]].split(',');
                                var products = [];

                                //Process Products
                                for (var k = 0; k < this.products.length; k++)
                                {
                                    //Loop and Build
                                    for (var j = 0; j < ids.length; j++)
                                    {
                                        if(this.products[k].id == ids[j])
                                        {
                                            products.push(this.products[k]);
                                        }
                                    }
                                }

                                //SEnd it
                                this.selected_products = products;
                            }
                            break;

                        case 'contract_status_id':
                            //Explode on Comma??
                            var ids = params[keys[i]].split(',');
                            var statuses = [];

                            //Process Products
                            for (var k = 0; k < this.contract_statuses.length; k++)
                            {
                                //Loop and Build
                                for (var j = 0; j < ids.length; j++)
                                {
                                    if(this.contract_statuses[k].id == ids[j])
                                    {
                                        statuses.push(this.contract_statuses[k].id);
                                    }
                                }
                            }

                            //SEnd it
                            this.contract_status_id = statuses.length > 0 ? statuses : this.default_statuses;
                            break;

                        case 'select_all':
                            //Check for the string version
                            if(params[keys[i]] == 'true' || params[keys[i]] == true)
                            {
                                this.select_all = true;
                            }
                            break;

                        default:
                            //Set it
                            this[keys[i]] = params[keys[i]];
                            break;
                    }
                }
            }
        },

        mounted() {
            //Get the resources
            this.getReport();
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style type="text/css">
    .multiselect__tag {
        background: #a7a7a7;
        font-size: 12px;
    }

    .multiselect__tag-icon:after {
        color: #484848;
        font-size: 12px;
    }

    .multiselect__tag-icon:focus,
    .multiselect__tag-icon:hover {
        background: #484848;
    }

    .multiselect__option,
    .multiselect__input,
    .multiselect__single,
    .multiselect__strong {
        font-size: 12px;
    }

    @media {
        .print-link-fix {
            text-decoration: none;
            color: #4E5155;
        }
    }

    @media (min-width: 576px) {
        .form-check .form-check-inline {
            display: inline-flex !important;
        }
    }
</style>